import React from 'react';
import { useAbortableGet } from '../sales/useAbortableGet';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const SkuPurchaseHistory = ({ skuCode, country }) => {
  const { data, loading } = useAbortableGet(skuCode ? `${API}/purchases/sku/${encodeURIComponent(skuCode)}/history?country=${country}&limit=10` : null);
  const rows = data?.rows || [];
  return (
    <div className="rounded-xl border border-gray-100 p-4" data-testid="sku-purchase-history">
      <p className="mb-2 text-[13px] font-semibold text-gray-800">Recent purchases</p>
      {loading && <p className="text-[12px] text-gray-500">Loading…</p>}
      {!loading && rows.length === 0 && <p className="text-[12px] text-gray-500" data-testid="sku-purchase-history-empty">No posted purchases yet</p>}
      {rows.length > 0 && (
        <div className="grid grid-cols-[95px_1fr_1fr_60px_90px] gap-x-3 gap-y-1 text-[12px]">
          {['Date', 'Invoice', 'Supplier', 'Qty', 'Unit cost'].map(h => <span key={h} className="font-medium text-gray-500">{h}</span>)}
          {rows.map((row, i) => (
            <React.Fragment key={`${row.purchase_id}-${i}`}>
              <span data-testid={`sku-purchase-history-date-${i}`}>{row.invoice_date}</span>
              <span className="truncate font-mono">{row.invoice_no}</span>
              <span className="truncate">{row.supplier}</span>
              <span className="text-right font-mono">{row.qty}</span>
              <span className="text-right font-mono">₹{Number(row.unit_cost || 0).toFixed(2)}</span>
            </React.Fragment>
          ))}
        </div>
      )}
    </div>
  );
};
